import React from 'react'
import Avatar from 'components/Avatar'
import ApartmentIcon from 'components/icons/ApartmentIcon'
import CustomTag from 'components/CustomTag'
import { COLORS } from 'theme'
import {
  SubFLex,
  SecondaryHeading,
  GreyText,
  StyledP,
  EditorContent,
  RewardTite
} from 'modules/Resume/Style/style'
import Flex from 'components/Flex'
import moment from 'moment'
import FileReaderVisibleOnly from 'components/Uploader/FileReaderVisibleOnly'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'

const PendingIcon = styled(ExclamationCircleFilled)`
  color: #eb5d60;
  font-size: 16px;
  margin-left: 8px;
`


const TrainingSection = ({ studentDetails, pendingData }) => {

  const hasFieldPending = (item, fieldName) => {
    return item?._pendingFields && item._pendingFields[fieldName] !== undefined
  }

  const approvedCourses = studentDetails?.resume?.courses || []
  const pendingCourses = pendingData?.resume?.courses || []

  const pendingMap = new Map()
  pendingCourses.forEach(pendingCourse => {
    if (pendingCourse.id || pendingCourse._itemId) {
      pendingMap.set(pendingCourse.id || pendingCourse._itemId, pendingCourse)
    }
  })

  const mergedCourses = approvedCourses.map(approvedCourse => {
    const pendingCourse = pendingMap.get(approvedCourse.id)

    if (pendingCourse && pendingCourse._pendingFields) {
      const merged = { ...approvedCourse }

      Object.keys(pendingCourse._pendingFields).forEach(fieldName => {
        merged[fieldName] = pendingCourse._pendingFields[fieldName].value
      })

      merged._hasPendingChanges = true
      merged._pendingFields = pendingCourse._pendingFields
      merged._requestId = pendingCourse._requestId

      return merged
    }

    return approvedCourse
  })

  const newPendingCourses = pendingCourses.filter(p =>
    p._isNew || (p.id && p.id.startsWith('temp-'))
  )

  const allCourses = [...mergedCourses, ...newPendingCourses]

  const DateDiff = (start, end) => {
    if (!start) {
      return '';
    }

    const StartSplit = start.split('/')
    if (!StartSplit || StartSplit.length < 2) {
      return '';
    }

    const EndSplit = end ? end.split('/') : null
    if (end && (!EndSplit || EndSplit.length < 2)) {
      return '';
    }

    try {
      const startDate = new Date(StartSplit[1], StartSplit[0], 1)
      const endDate = end ? new Date(EndSplit[1], EndSplit[0], 1) : new Date()

      const diffInMonths =
        (endDate.getFullYear() - startDate.getFullYear()) * 12 +
        (endDate.getMonth() - startDate.getMonth()) + 1

      if (diffInMonths >= 12) {
        const years = Math.floor(diffInMonths / 12)
        const months = diffInMonths % 12
        return `(${years === 1 ? years + ' year' : years > 1 ? years + ' years' : ''} ${months === 1 ? months + ' month' : months > 1 ? months + ' months' : ''})`;
      } else {
        return `(${diffInMonths === 1 ? diffInMonths + ' month' : diffInMonths > 1 ? diffInMonths + ' months' : ''})`;
      }
    } catch (error) {
      return '';
    }
  }

  return (

    <SubFLex column gap="25px">
      {allCourses.map((item, index) => (
        <SubFLex gap="12px" key={index + "courses"}>
          <div>
            <Avatar
              background="none"
              src={''}
              size={48}
              icon={<ApartmentIcon />}
              boxShadow={true}
              padding="5px"
            />
          </div>
          <SubFLex column style={{ width: '90%' }}>
            <Flex centerVertically gap="10px" wrap>
              <div style={{ flex: 1 }}>
                <SecondaryHeading style={{ margin: '1% 1% 1% 0', display: 'flex', alignItems: 'center' }}>
                  <span>{item?.title}{item?.organization ? ` - ${item?.organization}` : ''}</span>
                  {/* {(hasFieldPending(item, 'title') || hasFieldPending(item, 'organization')) && <PendingIcon />} */}
                </SecondaryHeading>
              </div>
              {(item?._pendingFields || item?._requestId) && (
                <>
                  <CustomTag
                    message="Verification Pending"
                    bordered={true}
                    background={'#eb5d60'}
                    border={'#eb5d60'}
                    color={'#fff'}
                  />
                </>
              )}
            </Flex>
            {(item?.started_in || item?.ended_in) && (
              <GreyText color={COLORS.GREY_T_60} style={{ display: 'flex', alignItems: 'center' }}>
                <span>
                  {item?.started_in && moment(item?.started_in, 'MM/YYYY').isValid() ? moment(item?.started_in, 'MM/YYYY')?.format('MMM YYYY') : ''} -{' '}
                  {item?.ended_in && moment(item?.ended_in, 'MM/YYYY').isValid() ? moment(item?.ended_in, 'MM/YYYY')?.format('MMM YYYY') : ''} {DateDiff(item?.started_in, item?.ended_in)}
                </span>
                {/* {(hasFieldPending(item, 'started_in') || hasFieldPending(item, 'ended_in')) && <PendingIcon />} */}
              </GreyText>
            )}
            {Array.isArray(item?.skill_set) && item?.skill_set?.length > 0 &&
              <SecondaryHeading fontWeight="600">
                Skills
              </SecondaryHeading>
            }
            <SubFLex centerVertically gap="5px" marginBottom="15px" wrap>
              {Array.isArray(item?.skill_set) && item?.skill_set?.map((value, key) => (
                <CustomTag
                  message={value?.name}
                  key={key + "skill"}
                  bordered={true}
                  background={'#F2F3F5'}
                  border={'#F2F3F5'}
                />
              ))}
            </SubFLex>

            {item?.description && (
              <StyledP style={{ display: 'flex', alignItems: 'flex-start' }}>
                <EditorContent
                  dangerouslySetInnerHTML={{
                    __html: item?.description || '',
                  }}
                />
                {/* {hasFieldPending(item, 'description') && <PendingIcon />} */}
              </StyledP>
            )}
            {/* {item?.certificate &&
              <FileReaderVisibleOnly file={item?.certificate} />
              } */}

            {item?.certificate &&
              Object.keys(item?.certificate).length > 0 && (
                <>
                  {hasFieldPending(item, 'certificate') ? (
                    <div
                      style={{
                        background: '#FFE5E6',
                        padding: '12px 16px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginTop: '8px',
                        marginBottom: '8px'
                      }}
                    >
                      <span style={{ fontSize: '14px', color: '#1F2937' }}>
                        Marksheet Submitted - <span style={{ color: '#3249D7', fontWeight: 500 }}>{item?.certificate?.name || 'Document.jpg'}</span>
                      </span>
                      <button
                        onClick={() => {
                          const newWindow = window.open(item?.certificate?.url, '_blank', 'noopener,noreferrer')
                          if (newWindow) newWindow.opener = null
                        }}
                        style={{
                          background: '#3249D7',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '6px',
                          padding: '6px 20px',
                          fontSize: '14px',
                          fontWeight: 500,
                          cursor: 'pointer'
                        }}
                      >
                        View
                      </button>
                    </div>
                  ) : (
                    <FileReaderVisibleOnly file={item?.certificate} />
                  )}
                </>
              )}
            {item?.awards?.length > 0 && studentDetails?.student?.isExpCandidate && (
              <RewardTite>Rewards and Recognition </RewardTite>
            )}
            {Array.isArray(item?.awards) && item?.awards?.map((value, key) => (

              <SubFLex column gap="25px" marginBottom="10px" key={key + "awards"}>
                <SubFLex gap="12px">
                  <div>
                    <Avatar
                      background="none"
                      src={''}
                      size={48}
                      icon={<AwardsIconWork />}
                      boxShadow={true}
                      padding="5px"
                    />
                  </div>
                  <SubFLex column style={{ width: '90%' }}>
                    {value?.title && (
                      <SecondaryHeading>{value?.title}</SecondaryHeading>
                    )}

                    {value?.awarded_on && (
                      <GreyText color={COLORS.GREY_T_60}>
                        {value?.awarded_on && moment(value?.awarded_on).isValid() ? moment(value?.awarded_on).format('DD MMM YYYY') : ''}
                      </GreyText>
                    )}

                    <StyledP>
                      {' '}
                      <EditorContent
                        dangerouslySetInnerHTML={{
                          __html: value?.description || '',
                        }}
                      />{' '}
                    </StyledP>
                    {value?.certificate && (
                      <FileReaderVisibleOnly file={value?.certificate} />
                    )}
                  </SubFLex>
                </SubFLex>
              </SubFLex>

            ))}
          </SubFLex>
        </SubFLex>
      ))}
    </SubFLex>

  )
}

export default TrainingSection